<template>
  <div class="bg-white promotion-activity" style="padding-bottom: 40px;">
    <div class="form">
      <h3 class="title">基本信息</h3>
      <div class="formContent">
        <el-form ref="form" :model="params" label-width="80px">
          <el-form-item label="活动名称" required>
            <div v-if="['readonly'].includes(mode)">{{ params.discountName }}</div>
            <el-input v-model="params.discountName" maxlength="25" show-word-limit style="width: 600px" placeholder="请输入" v-else></el-input>
          </el-form-item>
          <el-form-item label="活动描述">
            <div v-if="['readonly'].includes(mode)">{{ params.discountDescription }}</div>
            <el-input v-model="params.discountDescription" maxlength="25" show-word-limit style="width: 600px" placeholder="请输入" v-else></el-input>
          </el-form-item>
          <el-form-item label="活动时间" required>
            <div v-if="['readonly'].includes(mode)">
              <div>{{ `开始时间:${moment(params.startTime).format('YYYY-MM-DD HH:mm:ss')}` }}</div>
              <div>{{ `结束时间:${moment(params.endTime).format('YYYY-MM-DD HH:mm:ss')}` }}</div>
            </div>
            <section v-else>
              <el-date-picker v-model="params.startTime" type="datetime" placeholder="选择日期" style="margin-right: 14px" :picker-options="{disabledDate}" :disabled="startTimeDisabled">
              </el-date-picker>
              <el-date-picker v-model="params.endTime" type="datetime" placeholder="选择日期" :picker-options="{disabledDate: disabledDateOver}">
              </el-date-picker>
            </section>
          </el-form-item>
          <el-form-item label="促销类型" required>
            <div v-if="['readonly'].includes(mode)">{{ typeMap[params.type] }}</div>
            <el-select v-model="params.type" :disabled="['edit'].includes(mode)" v-else>
              <el-option :value="2" label="折扣活动"></el-option>
              <el-option :value="1" label="秒杀活动"></el-option>
              <el-option :value="3" label="节日促销活动"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="params.type !== 1">
            <el-form-item label="优惠规则" v-if="params.type === 2" required>
              <div v-if="['readonly'].includes(mode)">{{ priceParams2.discountPercent }} % off</div>
              <section v-else>
                <el-input style="width: 200px" v-model="priceParams2.discountPercent" @input="value=> numCheck(value, {target: priceParams2, key: 'discountPercent'})" :disabled="['edit'].includes(mode)"></el-input>% off
              </section>
            </el-form-item>
            <el-form-item label="优惠规则" v-if="params.type !==2" required>
              <div class="f--c">
                <div v-if="['readonly'].includes(mode)">{{ `${ruleMap[priceParams1.discountRule]} :  ` }} </div>
                <el-radio-group v-model="priceParams1.discountRule" :disabled="['edit'].includes(mode)" v-else>
                  <el-radio :label="1">固定折扣</el-radio>
                  <el-radio :label="2">固定减价</el-radio>
                </el-radio-group>
                <div v-if="priceParams1.discountRule == 1">
                  <div v-if="['readonly'].includes(mode)">{{ priceParams1.discountPercent }} % off</div>
                  <template v-else>
                    <el-input style="width: 200px;margin: 0px 14px;" v-model="priceParams1.discountPercent" @input="value=> numCheck(value, {target: priceParams1, key: 'discountPercent'})" :disabled="['edit'].includes(mode)"></el-input> % off
                  </template>
                </div>
                <div v-else>
                  <div v-if="['readonly'].includes(mode)">{{ priceParams1.discountFixed }}</div>
                  <el-input style="width: 200px;margin: 0px 14px" v-model="priceParams1.discountFixed" @input="value=> numCheck(value, {target: priceParams1, key: 'discountFixed'})" :disabled="['edit'].includes(mode)" v-else></el-input>
                </div>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="优先级" required>
            <div v-if="['readonly'].includes(mode)">{{ params.level }}</div>
            <el-input placeholder="请输入" v-model="params.level" style="width: 140px" @input="value=> numCheck(value, {target: params, key: 'level'})" v-else></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="params.type===3" class="config">
      <h3 class="title">活动页配置</h3>
      <div class="config-box">
        <!-- <div>
          导航栏是否显示：<el-switch v-model="productDiscountConfig.tabStatus" :active-value="1" :inactive-value="0" />
        </div>
        <div class="f">
          <div class="title">导航栏标识：</div>
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'tabImgurl')">
            <div v-if="productDiscountConfig.tabImgurl" class="img f-c-c">
              <img :src="productDiscountConfig.tabImgurl">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;padding: 0 40px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>高度固定82像素，（建议宽高比：447 x 82）</p>
            </div>
          </el-upload>
        </div> -->
        <div>
          首页是否显示：<el-switch v-model="productDiscountConfig.titleStatus" :active-value="1" :inactive-value="0" />
        </div>
        <div class="f">
          <div class="title">首页标题：</div>
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'titleImgurl')">
            <div v-if="productDiscountConfig.titleImgurl" class="img f-c-c">
              <img :src="productDiscountConfig.titleImgurl">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;padding: 0 40px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>高度固定135像素，（建议宽高比：1062 x 135）</p>
            </div>
          </el-upload>
        </div>
        <div class="f" style="margin-top:20px">
          <div class="title">活动页banner：</div>
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'bannerImgurl')">
            <div v-if="productDiscountConfig.bannerImgurl" class="img f-c-c">
              <img :src="productDiscountConfig.bannerImgurl">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;padding: 0 40px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>高度固定234像素，（建议宽高比：1400 x 234）</p>
            </div>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="config" v-if="[1, 2].includes(params.type)">
      <div class="config-box">
        <div class="f" style="margin-top:20px">
          <div class="title">活动页banner：</div>
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'bannerImgurl')">
            <div v-if="productDiscountConfig.bannerImgurl" class="img f-c-c">
              <img :src="productDiscountConfig.bannerImgurl">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;padding: 0 40px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>高度固定234像素，（建议宽高比：1400 x 234）</p>
            </div>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="table">
      <h3 class="title">促销商品</h3>
      <div class="btn f-b">
        <el-radio-group v-model="tabsActive" style="margin-left: 10px">
          <el-radio-button label="已在活动中"></el-radio-button>
          <el-radio-button label="待加入活动" :disabled="['readonly'].includes(mode)"></el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="chooseCommodity" :disabled="['readonly'].includes(mode) || (params.type === 1 && mode === 'edit')">选择商品</el-button>
      </div>
      <div v-show="tabsActive === '已在活动中'">
        <div v-if="inDiscountTableSelection.length" class="batchChangeSort f">
          <div class="label">批量设置优先级:</div>
          <el-input-number style="width: 160px;margin-right: 10px" v-model="batchSort"></el-input-number>
          <el-button @click="clearBatchSort">取消</el-button>
          <el-button @click="batchChangeSortSubmit('已在活动中')" type="primary">确定</el-button>
        </div>
        <el-table :data="tableInDiscount" style="width: 100%" row-key="kkProductId" @selection-change="selection => handleSelectionChange(selection, '已在活动中')" ref="tableInDiscount" max-height="800">
          <el-table-column type="selection" :reserve-selection="true" width="55" fixed>
          </el-table-column>
          <el-table-column label="图片" width="100" fixed>
            <template slot-scope="{row}">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image :src="row.images" fit="cover" />
                <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称" width="300" fixed>
          </el-table-column>
          <el-table-column label="款式"  width="300">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="906" trigger="hover">
                <div class="f fw-w">
                  <div v-for="sku in scope.row.skuCodes.split(',')" :key="sku" style="width: 220px;,margin-bottom: 4px">{{ sku }}</div>
                </div>
                <div class="ellipsis2" slot="reference">{{ `${scope.row.skuCodes.split(',').slice(0, 3).join(',')}...`}}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="可用库存" width="120">
          </el-table-column>
          <el-table-column prop="productStatus" label="状态" wdith="100">
            <template slot-scope="scope">
              {{ scope.row.productStatus === 1 ? '上架': '下架'}}
            </template>
          </el-table-column>
          <el-table-column label="排序优先级" width="240">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.productSort" @change="productLevelChange(scope.row)" :min="1"></el-input-number>
            </template>
          </el-table-column>
          <!-- 秒杀相关 -->
          <template v-if="params.type === 1">
            <el-table-column label="秒杀价格(USD)" width="240">
              <template slot="header">
                <spikePriceBatchPopove @change="spikePriceBatchChange" tab="已在活动中" :mode="mode"></spikePriceBatchPopove>
              </template>
              <template slot-scope="scope">
                <div class="p-r" style="text-align:center">
                    <el-input v-model="scope.row.spikePrice" @input="value=> numCheck(value, {target: scope.row, key: 'spikePrice'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikePrice')" :disabled="mode === 'edit'"></el-input>
                </div>
                <p class="inputNumberTip">实际售价:{{scope.row.price}} USD</p>
              </template>
            </el-table-column>
            <el-table-column width="240">
              <template slot="header">
                <spikeStockBatchPopove @change="spikeStockBatchChange" tab="已在活动中" :mode="mode" :tableList="tableInDiscount"></spikeStockBatchPopove>
              </template>
              <template slot-scope="scope">
                <div class="p-r" style="text-align:center">
                    <el-input v-model="scope.row.spikeTotalStock" @input="value=> numCheck(value, {target: scope.row, key: 'spikeTotalStock'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikeTotalStock')" :disabled="mode === 'edit'"></el-input>
                </div>
                <p class="inputNumberTip">实际总库存：{{scope.row.stock}}</p>
              </template>
            </el-table-column>
            <el-table-column label="秒杀已售数量" width="240">
              <template slot="header">
                秒杀已售数量<i class="el-icon-refresh-right pointer" @click="spikeSoldStockRandom('已在活动中')" style="margin-left: 4px;color:#add049"></i>
              </template>
              <template slot-scope="scope">
                <el-input v-model="scope.row.spikeSoldStock" @input="value=> numCheck(value, {target: scope.row, key: 'spikeSoldStock'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikeSoldStock', '已在活动中')"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="秒杀进度" width="240">
              <template slot-scope="scope">
                <el-progress :percentage="spikeProgress(scope.row, '已在活动中')" color="red"></el-progress>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row, '已在活动中')">
                <el-button type="text" slot="reference" style="color: red" :disabled="['readonly'].includes(mode) || (params.type === 1 && mode === 'edit')">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="f-e">
          <el-pagination @size-change="size=> handleSizeChange(size, 'paginationActivity')" @current-change="page => handleCurrentChange(page, 'paginationActivity')" :current-page="paginationActivity.pageNumber" :page-sizes="[50, 100, 200, 500]" :page-size="paginationActivity.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableInDiscountTotal">
          </el-pagination>
        </div>
      </div>
      <div v-show="tabsActive === '待加入活动'">
        <div v-if="storageTableCurrentSelection.length" class="batchChangeSort f">
          <div class="label">批量设置优先级:</div>
          <el-input-number style="width: 160px;margin-right: 10px" v-model="batchSort"></el-input-number>
          <el-button @click="clearBatchSort">取消</el-button>
          <el-button @click="batchChangeSortSubmit('待加入活动')" type="primary">确定</el-button>
        </div>
        <el-table :data="storageTableCurrent" style="width: 100%" row-key="kkProductId" ref="storageTableCurrent" @selection-change="selection => handleSelectionChange(selection, '待加入活动')" :fit="true" max-height="800">
          <el-table-column type="selection" :reserve-selection="true" width="55">
          </el-table-column>
          <el-table-column label="图片" width="100" fixed>
            <template slot-scope="{row}">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image :src="row.images" fit="cover" />
                <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称" fixed width="300">
          </el-table-column>
          <el-table-column label="款式" width="300">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="906" trigger="hover">
                <div class="f fw-w" v-if="scope.row.skuCodeJoin">
                  <div v-for="sku in scope.row.skuCodeJoin.split(',')" :key="sku" style="width: 220px;,margin-bottom: 4px">{{ sku }}</div>
                </div>
                <div v-else class="f fw-w">
                  <div v-for="sku in scope.row.skuCodes.split(',')" :key="sku" style="width: 220px;,margin-bottom: 4px">{{ sku }}</div>
                </div>
                <div class="ellipsis2" slot="reference">
                  <div v-if="scope.row.skuCodeJoin">{{ `${scope.row.skuCodeJoin.split(',').slice(0, 3).join(',')}...`}}</div>
                  <div v-else>{{ `${scope.row.skuCodes.split(',').slice(0, 3).join(',')}...` }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="realStockTotal" label="可用库存" width="140">
          </el-table-column>
          <el-table-column label="排序优先级" width="240" key="slot">
            <template #default="scope">
              <el-input-number style="width: 140px" v-model="scope.row.productSort" :min="1" />
            </template>
          </el-table-column>
          <template v-if="params.type === 1">
            <el-table-column width="240">
              <template slot="header">
                <spikePriceBatchPopove @change="spikePriceBatchChange" tab="待加入活动" :mode="mode" :tableList="tableDataStorageAll"></spikePriceBatchPopove>
              </template>
              <template slot-scope="scope">
                <div class="p-r">
                  <el-input v-model="scope.row.spikePrice" @input="value=> numCheck(value, {target: scope.row, key: 'spikePrice'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikePrice')"></el-input>
                </div>
                <p class="inputNumberTip">实际售价:{{scope.row.price}} USD</p>
              </template>
            </el-table-column>
            <el-table-column label="秒杀总库存" width="240">
              <template slot="header">
                <spikeStockBatchPopove @change="spikeStockBatchChange" tab="待加入活动" :mode="mode" ></spikeStockBatchPopove>
              </template>
              <template slot-scope="scope">
                <div class="p-r">
                  <el-input v-model="scope.row.spikeTotalStock" @input="value=> numCheck(value, {target: scope.row, key: 'spikeTotalStock'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikeTotalStock')"></el-input>
                </div>
                <p class="inputNumberTip">实际总库存：{{scope.row.virtualStockTotal === undefined? scope.row.stock: scope.row.virtualStockTotal}}</p>
              </template>
            </el-table-column>
            <el-table-column label="秒杀已售数量" width="240">
              <template slot="header">
                秒杀已售数量<i class="el-icon-refresh-right pointer" @click="spikeSoldStockRandom('待加入活动')" style="margin-left: 4px;color:#add049"></i>
              </template>
              <template slot-scope="scope">
                <el-input v-model="scope.row.spikeSoldStock" @input="value=> numCheck(value, {target: scope.row, key: 'spikeSoldStock'})" class="centerInput" @blur="spikeCheck(scope.row, 'spikeSoldStock')"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="秒杀进度" width="240">
              <template slot-scope="scope">
                <el-progress :percentage="spikeProgress(scope.row, '待加入活动')" color="red"></el-progress>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row, '待加入活动')">
                <el-button type="text" slot="reference" style="color: red">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="f-e">
          <el-pagination @size-change="size=> handleSizeChange(size, 'paginationStorage')" @current-change="page => handleCurrentChange(page, 'paginationStorage')" :current-page="paginationStorage.pageNumber" :page-sizes="[50, 100, 200, 500]" :page-size="paginationStorage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableDataStorageAll.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="submitBtn f-c">
      <el-button type="primary" style="width: 140px" @click="submit">提交</el-button>
    </div>
    <commodityDialog ref="commodityDialog" @selectSelection="selectSelection"></commodityDialog>
  </div>
</template>

<script>
import commodityDialog from './components/commodityDialog.vue';
import moment from 'moment'
import API from '@/api';
import _ from 'lodash'
import spikeStockBatchPopove from './components/spikeStockBatchPopove.vue'
import spikePriceBatchPopove from './components/spikePriceBatchPopove.vue'

const productDiscountConfig = { // 促销活动配置
  tabStatus: 0, // 活动导航栏状态：0-不显示；1-显示
  tabImgurl: '', // 活动导航栏图片
  titleStatus: 1, // 活动标题状态：0-不显示；1-显示
  titleImgurl: '', // 活动标题图片
  bannerImgurl: '', //活动banner图片
}

export default {
  components: {
    commodityDialog,
    spikeStockBatchPopove,
    spikePriceBatchPopove
  },
  data() {
    return {
      dateRange: [],
      tableInDiscount: [],
      tableInDiscountTotal: 0,
      params: {
        discountName: undefined,
        endTime: undefined,
        startTime: undefined,
        level: undefined,
        discountDescription: undefined,
        type: 1
      },
      priceParams1: {
        discountRule: 1,
        discountFixed: undefined,
        discountPercent: undefined
      },
      priceParams2: {
        discountPercent: undefined,
        discountRule: 1
      },
      tabsActive: '已在活动中',
      tableDataStorageAll: [],// 待加入活动商品
      paginationActivity: {
        pageNumber: 1,
        pageSize: 50
      },// 活动中
      paginationStorage: {
        pageNumber: 1,
        pageSize: 50
      },// 暂存
      id: undefined,
      discountId: undefined,
      moment,
      startTimeDisabled: false,
      mode: 'add',// 编辑edit  复制copy  只读readonly
      inDiscountTableSelection: [],
      batchSort: undefined,
      storageTableCurrentSelection: [],
      productDiscountConfig: _.cloneDeep(productDiscountConfig),
      radioSpike: 1,
      spikePriceBatchValue: undefined,
      spikeBatchVisible: false,
      spikeStockBatchValue: undefined,
      spikeStockBatchVisible: false,
      radio: 1
    }
  },
  computed: {
    storageTableCurrent() {
      const startIndex = ((this.paginationStorage.pageNumber - 1) * this.paginationStorage.pageSize)
      const endIndex = (startIndex + this.paginationStorage.pageSize)
      return this.tableDataStorageAll.slice(startIndex, endIndex)
    },
    typeMap() {
      const typeMap = {
        1: '限时促销',
        2: '折扣活动'
      }
      return typeMap
    },
    ruleMap() {
      const ruleMap = {
        1: '固定折扣',
        2: '固定减价'
      }
      return ruleMap
    },
    title() {
      let title = {
        add: '新增',
        edit: '编辑',
        copy: '复制',
        readonly: '详情'
      }
      return title[this.mode]
    }
  },
  created() {
    const { mode } = this.$route.query
    this.mode = mode
    if (['edit', 'readonly', 'copy'].includes(mode)) {
      const { id, discountId } = this.$route.query
      this.id = id
      this.discountId = discountId
      this.promotionDiscountDetail(this.id)
      this.promotionGetDetailProduct(this.discountId)
    }
  },
  methods: {
    async deleteRow(row, type) {
      if (type === '待加入活动') {
        const index = this.tableDataStorageAll.findIndex(e => e.id === row.id)
        this.tableDataStorageAll.splice(index, 1)
      } else {
        try {
          let res = await API.promotionProductDelete({ kkProductIds: [row.kkProductId], discountId: row.discountId })
          if (res.code !== 10000) {
            this.$message.error(res.message || '操作失败')
            return
          }
          this.$message.success('删除成功')
          this.promotionGetDetailProduct(this.discountId)
        } catch (error) {
          this.$message.error(error.data)
        }
      }
    },
    chooseCommodity() {
      this.$refs.commodityDialog.show()
    },
    // 已在活动中商品
    async promotionGetDetailProduct(discountId) {
      try {
        const params = Object.assign({}, this.paginationActivity, { discountId, copyFlag: this.mode === 'copy' })
        const res = await API.promotionGetDetailProduct(params)
        /*
          复制时 上次活动中的商品已不再是活动中，为待加入
        */
        if (this.mode === 'copy') {
          this.selectSelection(res.data.list)
        } else {
          this.tableInDiscount = res.data.list
          this.tableInDiscountTotal = res.data.total
          this.tableInDiscount.forEach(e=>{
            e.initialSpikeSoldStock = e.spikeSoldStock
          })
        }
      } catch (error) {
        this.$message.error(error.data)
      }
    },
    selectSelection(selection) {
      const res = new Map();
      if(['add', 'copy'].includes(this.mode)) {
        selection.forEach(e => {
          !e.productSort && this.$set(e, 'productSort', undefined)
          // 初始化秒杀key
          if(e.virtualStockTotal === undefined) e.virtualStockTotal = e.stock
          this.$set(e, 'spikePrice', e.price)
          this.$set(e, 'spikeTotalStock', e.virtualStockTotal)
          let num = parseInt(Math.random() * e.virtualStockTotal / 10 + e.virtualStockTotal/10)
          this.$set(e, 'spikeSoldStock', num)
          // 记录初始已售数量
          e.initialSpikeSoldStock = e.spikeSoldStock
        })
      }
      const arr = [...this.tableDataStorageAll, ...selection]
      this.tableDataStorageAll = arr.filter((item) => !res.has(item['kkProductId']) && res.set(item['kkProductId'], 1));
      this.tabsActive = '待加入活动'
    },
    getParams() {
      let params = Object.assign({}, this.params)
      if (params.type !==2) {
        params = Object.assign(params, this.priceParams1)
        params.discountRule === 1 && delete params.discountFixed
        params.discountRule === 2 && delete params.discountPercent
        if(params.type === 1) params.discountRule = undefined
      } else {
        params = Object.assign(params, this.priceParams2)
      }
      if (!params.discountName) {
        this.$message.error('活动名称必填!')
        return
      }
      if (!params.endTime || !params.startTime) {
        this.$message.error('活动时间必填!')
        return
      }
      if (
        // (params.type === 1 && params.discountRule === 1 && !params.discountPercent) ||
        // (params.type === 1 && params.discountRule === 2 && !params.discountFixed) ||
        (params.type === 2 && !params.discountPercent)
      ) {
        this.$message.error('请将优惠规则填写完整!')
        return
      }
      if (params.discountPercent && params.discountPercent >= 100) {
        this.$message.error('优惠折扣不可大于等于100')
        return
      }
      if (!params.level) {
        this.$message.error('优先级为必填且不能为0')
        return
      }
      params.startTime = moment(params.startTime).valueOf()
      params.endTime = moment(params.endTime).valueOf()
      params.discountDetails = [
        ...this.tableDataStorageAll.map(e => {
        return {
          kkProductId: e.kkProductId,
          productSort: e.productSort,
          spikeTotalStock: e.spikeTotalStock,
          spikeSoldStock: e.spikeSoldStock,
          spikePrice: e.spikePrice
        }
        }),
        ...this.tableInDiscount.map(e => {
          return {
            kkProductId: e.kkProductId,
            productSort: e.productSort,
            spikeTotalStock: e.spikeTotalStock,
            spikeSoldStock: e.spikeSoldStock,
            spikePrice: e.spikePrice,
            id: e.id
          }
        })
      ]
      if(this.mode === 'add' && !params.discountDetails.length) {
        this.$message.error('必须选择商品加入活动')
        return false
      }
      if (this.mode === 'edit') params.id = this.id
      if (params.startTime > params.endTime) {
        this.$message.error('开始时间不能大于结束时间')
        return false
      }
      // 新增的时候时间为此刻的时候 往后推两分钟
      if (['add', 'copy'].includes(this.mode)) {
        let nowTime = new Date().getTime()
        params.createOngoingDiscount = params.startTime < nowTime
      }
      // if(this.mode === 'edit' && params.type === 1 && this.tableInDiscount.some(e=> e.initialSpikeSoldStock > e.spikeSoldStock)) {
      //   this.$message.error('销售数量不能比初始的小')
      //   return
      // }

      // 活动页配置
      let config = _.cloneDeep(productDiscountConfig)
      for (let key in config) {
        config[key] = this.productDiscountConfig[key]
      }
      if (this.productDiscountConfig.id) config.id = this.productDiscountConfig.id
      params.productDiscountConfig = config
      if(params.type === 3) {
        // if (!config.tabImgurl) {
        //   this.$message.error('请上传活动导航栏图片')
        //   return
        // }
        if (!config.titleImgurl) {
          this.$message.error('请上传活动标题图片')
          return
        }
        if (!config.bannerImgurl) {
          this.$message.error('请上传活动banner图片')
          return
        }
      }
      if([1, 2].includes(params.type)) {
        if (!config.bannerImgurl) {
          this.$message.error('请上传活动banner图片')
          return
        }
      }

      // 新增复制时只取需要字段
      if (['add', 'copy'].includes(this.mode)) {
        const { discountDetails, discountName, discountDescription, level, discountPercent, discountRule, endTime, startTime, type, discountFixed, createOngoingDiscount } = params
        let param = { discountDetails, discountName, discountDescription, level, discountPercent, discountRule, endTime, startTime, type, discountFixed, createOngoingDiscount }
        if([1, 2].includes(type)) {
          const { bannerImgurl, id } = params.productDiscountConfig
          param.productDiscountConfig = {
            bannerImgurl,
            id
          }
        }
        if (type === 3) {
          param.productDiscountConfig = params.productDiscountConfig
        }
        return param
      }
      return params
    },
    async submit() {
      try {
        const params = this.getParams()
        if (!params) return
        let res = null
        // 复制相当于新增
        if (['add', 'copy'].includes(this.mode)) {
          res = await API.promotionAdd(params)
        } else {
          res = await API.promotionEdit(params)
        }
        if (res.code !== 10000) {
          this.$message.error(res.message || '操作失败')
          return
        }
        this.$message.success('操作成功')
        this.$router.push('/operation/Promotion/list')
      } catch (error) {
        this.$message.error(error.data)
      }
    },
    disabledDate(date) {
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    disabledDateOver(date) {
      if (this.params.startTime) return date.getTime() < this.params.startTime
      else return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    numCheck(value, info) {
      const { target, key } = info
      let finalValue = value.replace(/[^\d.]/g, '')
      if(finalValue.startsWith('0')) finalValue = undefined
      if(+finalValue === 0) finalValue = undefined
      if (!finalValue) finalValue = undefined
      target[key] = finalValue
    },
    numBlur(value, info) {
      const { target, key } = info
    },
    handleCurrentChange(page, which) {
      this[which].pageNumber = page
      which === 'paginationActivity' && this.promotionGetDetailProduct(this.discountId)
    },
    handleSizeChange(size, which) {
      this[which].pageSize = size
      which === 'paginationActivity' && this.promotionGetDetailProduct(this.discountId)
    },
    async promotionDiscountDetail(id) {
      try {
        const res = await API.promotionDiscountDetail(id)
        const { discountRule, discountFixed, discountPercent, ...params } = res.data
        this.params = Object.assign(this.params, params)
        this.priceParams1 = { discountRule, discountFixed, discountPercent }
        this.priceParams2 = Object.assign(this.priceParams2, { discountPercent })
        this.startTimeDisabledCheck()
        // if (this.params.type === 3) this.promotionProductDiscountConfig(this.discountId)
        this.promotionProductDiscountConfig(this.discountId)
        /*
          复制时  将优先级、结束时间清空
        */
        if (this.mode === 'copy') {
          this.params.endTime = undefined
          this.params.level = undefined
        }
      } catch (error) {
        this.$message.error(error.data)
      }
    },
    promotionProductDelete(row) {
      console.log(row)
    },
    startTimeDisabledCheck() {
      if (['edit'].includes(this.mode)) {
        this.startTimeDisabled = (this.params.startTime < new Date().getTime())
      }
    },
    productLevelChange: _.debounce(function (row) {
      const { productSort, id } = row
      API.promotionProductDeleteLevel({ discountDetails: [{ productSort: productSort || null, id }] }).then(() => {
        this.$message.success('更改成功')
        this.promotionGetDetailProduct(this.discountId)
      })
    }, 500),
    handleSelectionChange(selection, type) {
      if (type === '已在活动中') this.inDiscountTableSelection = selection
      if (type === '待加入活动') {
        this.storageTableCurrentSelection = selection
      }
    },
    batchChangeSortSubmit(active) {
      if (!this.batchSort) {
        this.$message.error('请输入排序优先级')
        return
      }
      if (active === '已在活动中') {
        const discountDetails = this.inDiscountTableSelection.map(e => ({ productSort: this.batchSort, id: e.id }))
        API.promotionProductDeleteLevel({ discountDetails }).then(() => {
          this.$message.success('更改成功')
          this.clearBatchSort()
          this.promotionGetDetailProduct(this.discountId)
        })
      } else {
        const kkProductIds = this.$refs.tableDataStorageAll.selection.map(e => e.kkProductId)
        this.tableDataStorageAll.forEach(e => kkProductIds.includes(e.kkProductId) && this.$set(e, 'productSort', this.batchSort))
        this.clearBatchSort()
      }
    },
    clearBatchSort() {
      this.inDiscountTableSelection = []
      this.storageTableCurrentSelection = []
      this.$refs.tableInDiscount.clearSelection()
      this.$refs.storageTableCurrent.clearSelection()
      this.batchSort = undefined
    },
    // 上传
    beforeUpload(file, type) {
      API.signValue({ directory: 'activity/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'activity/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(this.productDiscountConfig, type, result.data)
        })
      })
      return false
    },
    // 获取活动设置
    promotionProductDiscountConfig(discountId) {
      API.promotionProductDiscountConfig({ discountId }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.productDiscountConfig = res.data || _.cloneDeep(productDiscountConfig)
      })
    },
    // 秒杀活动数值校验
    spikeCheck(row, key, tab) {
      /*
        spikeTotalStock 秒杀总库存
        spikeSoldStock  秒杀已售数量
        spikePrice      秒杀价格
      */
     switch (key) {
      case 'spikeTotalStock':
        if(row.spikeTotalStock > row.virtualStockTotal) {
          row.spikeTotalStock = row.virtualStockTotal
        }
        if(row.spikeSoldStock > row.spikeTotalStock) row.spikeSoldStock = row.spikeTotalStock
        row.spikeTotalStock = parseInt(row.spikeTotalStock)
        // 已售数量联动
        row.spikeSoldStock = parseInt(Math.random() * row.spikeTotalStock / 10 + row.spikeTotalStock/10)
        break;
      case 'spikeSoldStock':
        row.spikeSoldStock ? row.spikeSoldStock = parseInt(row.spikeSoldStock): row.spikeSoldStoc = 0
        if(row.spikeSoldStock > row.spikeTotalStock) row.spikeSoldStock = row.spikeTotalStock
        break;
      case 'spikePrice':
        if(row.spikePrice > row.price) row.spikePrice = row.price
        if(row.spikePrice) row.spikePrice = +parseFloat(row.spikePrice).toFixed(2)
        break
      default:
        console.log('')
        break;
     }
    },
    spikeProgress(row, tab) {
        if(row.spikeSoldStock/row.spikeTotalStock*100 > 100) return 100
        if(Number.isNaN(parseInt(row.spikeSoldStock/row.spikeTotalStock*100))) return 0
        return parseInt(row.spikeSoldStock/row.spikeTotalStock*100)
    },
    spikeSoldStockRandom(tab) {
      switch (tab) {
        case '已在活动中':
          this.tableInDiscount.forEach(e=>{
            let num = parseInt(Math.random() * e.spikeTotalStock / 10 + e.spikeTotalStock/10)
            if(this.mode === 'edit') {
              num = parseInt(e.spikeSoldStock +parseInt(Math.random() * e.spikeTotalStock / 10))
              if(num > e.spikeTotalStock) num = e.spikeTotalStock
            }
            this.$set(e, 'spikeSoldStock', num)
          })
          break;
        case '待加入活动':
          this.tableDataStorageAll.forEach(e=>{
            let num = parseInt(Math.random() * e.spikeTotalStock / 10 + e.spikeTotalStock/10)
            if(this.mode === 'edit') {
              num = parseInt(e.spikeSoldStock +parseInt(Math.random() * e.spikeTotalStock / 10))
              if(num > e.spikeTotalStock) num = e.spikeTotalStock
            }
            this.$set(e, 'spikeSoldStock', num)
          })
          break;
        default:
          break;
      }
    },
    spikeStockBatchChange({tab, value}) {
      if(!value) return
      this[tab].forEach(e=>{
        e.spikeTotalStock = value
        this.spikeCheck(e, 'spikeTotalStock')
      })
      this.spikeSoldStockRandom(tab === 'tableInDiscount' ? '已在活动中': '待加入活动')
    },
    spikePriceBatchChange({type, value, tab}) {
      /*
        type 1 固定折扣 秒杀价格 = 实际售价 * （1-折扣）
             2 固定减价 秒杀价格 = 实际售价 - 固定金额
      */
      if(!value) return
      if(type ===1) {
        this[tab].forEach(e=>{
          if(value > 100) value = 100
          e.spikePrice = +(e.price * (1- value/100)).toFixed(2)
        })
      } else {
        if(this[tab].some(e=>e.price < value)) {
          this.$message.error('减价金额必须小于最小实际售价')
          return
        }
        this[tab].forEach(e=>{
          e.spikePrice = +(e.price - value).toFixed(2)
          if(e.spikePrice < 0) e.spikePrice  = 0
        })
      }
    }
  }
}
</script>

<style lang="scss">
.promotion-activity {
  .form {
    .title {
      padding: 20px 10px;
    }
    .formContent {
      padding: 10px 30px;
    }
  }
  
  .config {
    h3 {
      padding: 20px 10px;
    }
    .config-box {
      padding: 0 50px;
      
      .title {
        flex-shrink: 0;
      }

      >div {
        padding-bottom: 30px;
      }      
  
      .upload-img {
        min-height: 100px;
        border: 1px dotted #999;
  
        p {
          font-size: 14px;
          color: #999;
        }
  
        .el-upload {
          height: 100%;
          display: block;
          .avatar-uploader-icon {
            font-size: 30px;
            font-weight: bold;
          }
  
          .img {
            height:100%;
            img{
              width: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  
  .table {
    .title {
      padding: 20px 10px;
    }
    .btn {
      padding: 0 10px;
      margin-bottom: 10px;
    }
  }
  .submitBtn {
    background-color: #fff;
    padding: 40px 0 20px;
  }
  .batchChangeSort {
    padding: 0 20px;
    .label {
      height: 40px;
      line-height: 40px;
      margin-right: 8px;
    }
  }
}
.inputNumberTip{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
}
.stock-img{
  min-height:80px
}
.centerInput{
  .el-input__inner{
    text-align: center;
  }
}
</style>

